import React__default from 'react';
import ReactSkeleton from 'react-loading-skeleton';

const SuspenseFallback = () => {
    return React__default.createElement(ReactSkeleton, { height: "200px", width: "100%" });
};

export { SuspenseFallback as default };
//# sourceMappingURL=SuspenseFallback.js.map
